<template>
  <div class="content_admin_crm">

    <!-- Nav tabs -->
    <div class="d-flex justify-content-center">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="home-tab" data-toggle="tab" data-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Inicio</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="mailing-tab" data-toggle="tab" data-target="#mailing" type="button" role="tab" aria-controls="mailing" aria-selected="false">Mailing</button>
        </li>
        <li class="nav-item" role="presentation">
          <button 
            @click="loadMetricsComponent()"
            class="nav-link" id="metrics-tab" data-toggle="tab" data-target="#metrics" type="button" role="tab" aria-controls="messages" aria-selected="false">Métricas Mailing</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="rrss-tab" data-toggle="tab" data-target="#rrss" type="button" role="tab" aria-controls="rrss" aria-selected="false">Analytics y RRSS</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="dashboard-tab" data-toggle="tab" data-target="#dashboard" type="button" role="tab" aria-controls="dashboard" aria-selected="false">Dashboard / Motoclub</button>
        </li>
      </ul>
    </div>

    <!-- Tab panes -->
    <div class="tab-content">

      <!-- Tab Inicio -->
      <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
        <h1 style="background-color:#dc3545; color:white; padding:10px 0px;">CRM Havoline</h1>

        <div id="accordion">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Como enviar emails
                </button>
              </h5>
            </div>

            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
              <div class="card-body">
                <p class="info">
                  Para realizar el envío de correos electrónicos, de click sobre el botón "Mailing", 
                  allí encontrará el formulario con los respectivos campos para realizar el envío.
                </p>
                <strong class="desc_fields">Descripción de campos:</strong>
                <p>
                  <strong class="b_fields">Asunto del email: </strong><span>Aquí colocamos el aunto del email.</span><br>
                  <strong class="b_fields">Contenido: </strong>
                  <span class="info">
                    En este campo tenemos 3 opciones de contenido, 
                    TEXTO: Con esta opción podemos agregar contenido que sea por ejemplo simplemente texto informativo.
                    HTML: Eligiendo esta opción podremos agregar contenido Html para conformar el cuerpo del email.
                    CONTENIDO PERSONALIZADO: Usando esta última opción el sistema agregará el nombre del usuario dentro del email
                    por ejemplo si queremos desearle un buen día a los usuarios solo debemos escribir el mensaje de la siguiente forma
                    "Hola {nombre} que tengas un buen día", de esta forma el sistema reemplazará "{nombre}" por el nombre real del usuario.
                  </span><br>
                  <strong class="b_fields">Destinatarios: </strong>
                  <span class="info">
                    En este campo tenemos 3 opciones de destinatarios,
                    en la primera opción "POR DISTRIBUIDOR" debemos escoger un distribuidor y luego se habilita un campo para seleccionar
                    el tipo de usuario que tenga asignado a ese distribuidor, la segunda opción "POR TIPO DE USUARIO" nos permite elegir el tipo
                    de usuario al que le vamos a enviar el email, el listado nos da la opción de escoger Moteros, Lubricadores o Ambos,
                    y la última opción "ARCHIVO EXCEL" nos permiter escoger un archivo excel de nuestro equipo con el listado de 
                    correos electrónicos a los cuales enviaremos nuestro email, esta es la estructura obligatoria para el archivo a subir<br>
                    <img alt="Información" class="img_excel" style="box-shadow:0px 0px 10px black;" src="../../../../assets/img/estructura_excel.png"><br>
                    <strong class="b_fields">email: </strong><span>Listado de correos electrónicos</span><br>
                    <strong class="b_fields">rol: </strong><span>El rol del usuario, 4 = Lubricador, 5 = Motero</span><br>
                    <strong class="b_fields">distribuidor: </strong><span>El nombre (en mayúsculas) del distribuidor</span><br>
                  </span><br>
                </p>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Visualización de métricas
                </button>
              </h5>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
              <div class="card-body">
                <p class="info">
                  Para visualizar las métricas de los correos electrónicos, de click sobre el botón "Métricas Mailing", 
                  allí encontrará una tabla con los registros de los envíos y en la parte de abajo una gráfica con las métricas.
                  La gráfica inicial muestra los datos totales de los envíos realizados, para ver una gráfica con los datos 
                  de un solo envío debe ubicar el registro en la tabla e ir a la columna "Acción" y dar click sobre "Ver datos en gráfica",
                  de esta forma se visualizarán los valores correspondientes a ese envío.
                  Para obtener nuevamente los datos totales sobre la gráfica debe dar click sobre el botón "Ver total",
                  también podrá descargar la tabla de las métricas dando click en el botón "Descargar en Excel".
                </p>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header" id="headingThree">
              <h5 class="mb-0">
                <button class="btn btn-link" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseTwo">
                  Analytics y RRSS
                </button>
              </h5>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
              <div class="card-body">
                <p class="info">
                  El apartado presenta un dashboard que resume métricas de rendimiento para las cuentas de Facebook e Instagram de Havoline Colombia, 
                  así como Google Analytics para Havoline Motoclub. Incluye gráficos visuales sobre alcance, participación, 
                  crecimiento de seguidores y datos analíticos como tráfico web y conversiones. 
                  Esta herramienta centralizada, agiliza la evaluación y toma de decisiones 
                  para optimizar estrategias de marketing digital en el contexto específico de Havoline.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Tab Mailing -->
      <div class="tab-pane" id="mailing" role="tabpanel" aria-labelledby="mailing-tab">
        <mailing></mailing>
      </div>

      <!-- Tab Métricas -->
      <div class="tab-pane fade" id="metrics" role="tabpanel" aria-labelledby="metrics-tab">
        <metrics v-if="loadMetrics"></metrics>
      </div>

      <!-- Tab RRSS -->
      <div class="tab-pane fade" id="rrss" role="tabpanel" aria-labelledby="rrss-tab">
        <rrss></rrss>
      </div>

      <!-- Tab Dashboard / Motoclub -->
      <div class="tab-pane fade" id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
        <dashboard></dashboard>
      </div>
    </div>

  </div>
</template>

<script>
// import axios from 'axios';
import mailing from '../crm/mailing/sendEmails.vue';
import metrics from '../crm/mailing/emailMetrics.vue';
import rrss from '../crm/rrss/analyticsRrss.vue';
import dashboard from '../crm/dashboard/dashboard.vue';

export default {
  name: "adminCrm",

  components:{
    mailing,
    metrics,
    rrss,
    dashboard
  },

  data(){
    return{
      loadMetrics: false,
      loadChart: false,

      // Opciones Motoclub
      items: [
        {
          id: 1,
          name: "Usuarios registrados"
        },
        {
          id: 2,
          name: "Códigos"
        },
        {
          id: 3,
          name: "Modelo de puntos"
        },
        {
          id: 4,
          name: "Redenciones"
        },
        {
          id: 5,
          name: "Actualización de datos"
        },
        {
          id: 6,
          name: "Alianzas"
        },
      ],
    };
  },
  methods:{
    loadMetricsComponent() {
      this.loadMetrics = true;
    },
  },
  mounted(){

  }
};
</script>

<style scoped>
/* DESKTOP */
.content_admin_crm{
  padding: 8% 15px 15% 15px;
}
.nav-tabs{
  /* border: none; */
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.nav-link, .btn-link{
  color: black;
  border: 1px solid #dc3545;
  margin-right: 5px;
  border-radius: 5px;
  text-decoration: none;
  float: left;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active{
  background-color: #dc3545 !important;
  border: 1px solid #dc3545;
  color: white;
}
.tab-pane > h1, h2{
  color: black;
  font-family: "GothamBoldItalic", sans-serif;
}
.card-body{
  display: grid;
  width: 100%;
  color:#595959;
  padding: 20px 50px;
}
.card-body > p{
  width: 100%;
  text-align: left;
}
.card-body > b{
  width: 100%;
  text-align: left;
  padding: 5px 0px;
}
.img_excel{
  margin: 10px auto 15px 0px;
}
#rrss{
  background-color: #eaeaea;
}
.info{
  text-align: justify !important;
}
.button{
  float: left;
}

/* Fuentes */
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}


/* MOBILE */
@media (max-width: 767px) {
  .content_admin_crm {
    padding: 20% 15px 20% 15px;
  }
  .nav-link, .btn-link {
    margin: 5px;
  }
  .card-body{
    padding: 20px 20px !important;
  }
  .desc_fields, .b_fields{
    font-size: 20px !important;
  }
  .info{
    font-size: 18px !important;
  }
  .img_excel{
    width: 300px;
    margin: 10px auto 15px 0px;
  }
}
</style>